
    import I18n from 'i18nObj';
    
      import 'translations/editor_accessibility';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('editor_accessibility');
  